import { render, staticRenderFns } from "./buys.vue?vue&type=template&id=293ea82f&"
import script from "./buys.vue?vue&type=script&lang=js&"
export * from "./buys.vue?vue&type=script&lang=js&"
import style0 from "./buys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports